import { render, staticRenderFns } from "./cjSearch.vue?vue&type=template&id=0475c1b9&scoped=true"
import script from "./cjSearch.vue?vue&type=script&lang=js"
export * from "./cjSearch.vue?vue&type=script&lang=js"
import style0 from "./cjSearch.vue?vue&type=style&index=0&id=0475c1b9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0475c1b9",
  null
  
)

export default component.exports